/** @format */

import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { LoaderModule } from '../../../../../../dist/sesio-lib';
import { IHeaderSearch } from '../../_classes/header-search';
import EquipmentRequestService from '../../_services/equipment-request.service';
import { DatagridComponent, IOptions } from '../datagrid/datagrid.component';
import { DatagridModule } from '../datagrid/datagrid.module';
import { IRecord } from '../datagrid/datasource';
import { IDatatableOptions, IDatatableRecords } from '../datagrid/datatable.class';
import { EquipmentRequestDatagridEditModal } from './edit-modal/equipment-request-datagrid-edit.modal';

@Component({
  selector: 'app-equipment-request-datagrid',
  templateUrl: './equipment-request-datagrid.component.html',
  standalone: true,
  imports: [CommonModule, DatagridModule, LoaderModule, IonicModule],
})
export class EquipmentRequestDatagridComponent {
  private service = inject(EquipmentRequestService);

  @Input()
  filter!: IHeaderSearch;

  options: IOptions = {
    columns: [
      {
        label: 'Statut',
        property: 'status',
        width: 200,
        type: 'select',
        options: [
          { value: 'requested', name: 'En cours' },
          { value: 'refused', name: 'Refusée' },
        ],
        sortable: true,
        searchable: true,
      },
      {
        property: 'kind.name',
        label: 'kind',
        searchable: true,
        sortable: true,
      },
      {
        label: 'organizational-unit',
        property: 'organizationalUnit._id',
        displayProperty: 'organizationalUnit.pathNames',
        color: 'var(--ion-color-medium)',
        searchable: true,
        sortable: true,
        displayWith: (record: any) => record?.organizationalUnit?.pathNames?.slice(1).join(' > '),
      },
      {
        label: 'real-estate-structure',
        property: 'realEstateStructure._id',
        displayProperty: 'realEstateStructure.pathNames',
        color: 'var(--ion-color-medium)',
        searchable: true,
        sortable: true,
        displayWith: (record: any) => record?.realEstateStructure?.pathNames?.join(' > '),
      },
      {
        property: 'contractor',
        label: 'Prestataire',
        displayProperty: 'contractor.name',
        searchProperty: 'contractor.name',
        linkedProperties: ['contractor._id', 'contractor.name'],
        color: 'var(--ion-color-secondary)',
        searchable: true,
        sortable: true,
      },
      {
        property: 'externalReference',
        label: 'Référence prestataire',
        searchable: true,
        sortable: true,
      },
    ],
    pagination: { default: 2, options: [10, 20, 50, 100] },
    service: (options: IDatatableOptions): Observable<IDatatableRecords<IRecord>> =>
      this.service.datatable(options, this.filter),
    enableRowNumber: false,
    enableStickyColumn: false,
    enableReorderColumn: false,
    enableSelect: false,
    enableHideShowColumns: false,
    enableExport: true,
    rowClick: (datagrid: DatagridComponent, record: IRecord) => this.edit(datagrid, record),
    actions: [{ icon: { name: 'add_circle_outline' }, exec: datagrid => this.edit(datagrid) }],
  };

  private modal: HTMLIonModalElement;
  private modalController = inject(ModalController);
  public async edit(datagrid: DatagridComponent, record?: IRecord): Promise<void> {
    if (this.modal) return;

    this.modal = await this.modalController.create({
      component: EquipmentRequestDatagridEditModal,
      backdropDismiss: false,
      cssClass: 'xwide-modal',
      componentProps: { id: record?._id },
    });
    await this.modal.present();

    const res = await this.modal.onDidDismiss();
    if (res.data) datagrid.loadPage();
    this.modal = null;
  }
}
